import React, { useEffect, useState } from 'react';
import AnalysisDashboardUI from './AnalysisDashboardUI';
import { getDashboardApi } from '../../apis/dashboard.api';
import { callApiAction } from '../../store/actions/commonAction';
import { useDispatch } from 'react-redux';
import moment from 'moment';

const AnalysisDashboardController = () => {
    const [loading, setLoading] = useState(false);
    const [chartData, setChartData] = useState([]);
    const [productNames, setProductNames] = useState([]);
    const dispatch = useDispatch();

    const [filters, setFilters] = useState({
        product_id: "",
        source_id: "",
        productName: "",
        country: "",
        state: "",
        city: "",
        category: "",
        isDashboard: true,
        categories: "",
        date: {
            start: moment().subtract(1, 'year'),
            end: moment().subtract(0, 'year'),
        }

    });

    const fetchList = () => {
        setLoading(true);
        dispatch(
            callApiAction(
                async () => await getDashboardApi({
                    product_id: filters?.product_id,
                    source_id: filters?.source_id,
                    country: filters?.countryName,
                    state: filters?.stateName,
                    city: filters?.cityName,
                    // categories: filters?.categories,
                    date: filters?.date
                }),
                (response) => {
                    setLoading(false);
                    setChartData(response);
                },
                (err) => {
                    setLoading(false);
                }
            )
        );
    };

    useEffect(() => {
        if (filters?.product_id || filters?.source_id || filters?.country || filters?.state || filters?.city || filters?.date ) {
            fetchList();
        }
    }, [filters?.product_id , filters?.source_id, filters?.country ,filters?.state, filters?.city, filters?.date]);

    return (
        <AnalysisDashboardUI
            loading={loading}
            chartData={chartData}
            productNames={productNames}
            setFilters={setFilters}
            filters={filters}
        />
    );
};

export default AnalysisDashboardController;
